
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g04vfGAwspQ0xMAEilCNorEkqiBB9XC2rrq55uZQVaWwMeta } from "/codebuild/output/src3179856514/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexm4el6szJybZOCUwA6iMVcSUItA_456b9QrfsPKRYE_45p_4Meta } from "/codebuild/output/src3179856514/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchPvSM_45DDXsUv1RpTtigResK8Sg4JyaWqpe24KgHei2xUMeta } from "/codebuild/output/src3179856514/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexqoNXDLHSAFI4ue37SckKji9I_jAIYy_ZzuXLbkLPvsQMeta } from "/codebuild/output/src3179856514/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93QYUPXgRcbBJCMrfeGqyzQkWpxS06g1_MU2pmRhV6pvUMeta } from "/codebuild/output/src3179856514/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexkMogUhTaE2GdKea5YneB_45WRNFdoc6BdnLM8f_HhXEd8Meta } from "/codebuild/output/src3179856514/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93vVgMgFo4UQf9xaRaTgK3kRcT7J7mnurUFNB7H7c4HKkMeta } from "/codebuild/output/src3179856514/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexn2nIZ88PpYWSyiCD9oDaU_454pSNwQsa1B_45zQY9Y5o9LkMeta } from "/codebuild/output/src3179856514/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_939PSTepCqMVBZ02MFP7HtWREwVEyjTiNt8VV4uV4IuAQMeta } from "/codebuild/output/src3179856514/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexMz4Ov2KRpPba6icbpSwM6dE9a4CYswnBAWveFIIfjmcMeta } from "/codebuild/output/src3179856514/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexR9toSuLZWGIGaNi7o6vx56_SQTc_45tqJWwtOdNoggVDwMeta } from "/codebuild/output/src3179856514/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3179856514/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3179856514/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3179856514/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3179856514/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3179856514/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexkMogUhTaE2GdKea5YneB_45WRNFdoc6BdnLM8f_HhXEd8Meta || {},
    component: () => import("/codebuild/output/src3179856514/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3179856514/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexn2nIZ88PpYWSyiCD9oDaU_454pSNwQsa1B_45zQY9Y5o9LkMeta || {},
    component: () => import("/codebuild/output/src3179856514/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3179856514/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexMz4Ov2KRpPba6icbpSwM6dE9a4CYswnBAWveFIIfjmcMeta || {},
    component: () => import("/codebuild/output/src3179856514/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexR9toSuLZWGIGaNi7o6vx56_SQTc_45tqJWwtOdNoggVDwMeta || {},
    component: () => import("/codebuild/output/src3179856514/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]